import { BreadcrumbItemProps } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

import { TABLE_VIEW } from '../../common/foreclosureMonitoringTypes'
import {
  addressPath,
  areaPath,
  auctionMapPath,
  auctionMonitoringPath,
  ceeCheckPath,
  ceeMonitorPath,
  cuzkDocumentCollectionPath,
  cuzkEpoPath,
  cuzkLvPath,
  cuzkMonitorRcPath,
  foreclosureMapPath,
  foreclosureMonitoringPath,
  heritageMonitoringPath,
  homePath,
  insolvencyMapPath,
  insolvencyMonitoringPath,
  labelPath,
  lvPath,
  proceedingPath,
  propertyNotePath,
  subjectPath,
  tabQuery,
  viewPath,
  watchdogChannelPath,
  watchdogPropertyPath,
} from './paths'
import { MONITORING_TAB_KEYS } from './tabsHelpers'

export interface BreadcrumbConfig {
  path: string
  name: string
  title?: string
  menu?: BreadcrumbItemProps['menu']
  children?: BreadcrumbConfig[]
  tabLabels?: Record<string, string>
  dynamicLabels?: Record<string, (param: string) => string>
  disabled?: boolean
}

export const menuItem = (to: string, title: string) => ({
  key: title,
  label: <Link to={to}>{title}</Link>,
})

export const propertyDropdown = {
  items: [
    menuItem(areaPath(), MONITORING_TAB_KEYS.AREA),
    menuItem(addressPath(), MONITORING_TAB_KEYS.BUILDING),
    menuItem(addressPath(), MONITORING_TAB_KEYS.UNIT),
  ],
}
export const overviewDropdown = {
  items: [
    menuItem(homePath(), 'Vývoj aplikace'),
    menuItem(propertyNotePath(), 'Poznámky'),
    menuItem(labelPath(), 'Štítky'),
  ],
}
export const searchDropdown = {
  items: [
    menuItem(addressPath(), 'Adresa'),
    menuItem(areaPath(), 'Parcela'),
    menuItem(lvPath(), 'List vlastnictví'),
    menuItem(proceedingPath(), 'Řízení'),
    menuItem(subjectPath(), 'Subjekt'),
    // menuItem(dataBoxPath(), 'Datová schránka'),
  ],
}
export const ceeDropdown = {
  items: [
    menuItem(ceeCheckPath(), 'Vyhledat'),
    menuItem(ceeMonitorPath(), 'Hlídat'),
  ],
}
export const monitoringDropdown = {
  items: [
    menuItem(foreclosureMonitoringPath(), 'Exekuce'),
    menuItem(insolvencyMonitoringPath(), 'Insolvence'),
    menuItem(heritageMonitoringPath(), 'Dědictví'),
    menuItem(auctionMonitoringPath(), 'Dražby'),
    menuItem(watchdogPropertyPath(), 'Hlídač katastru'),
  ],
}
export const foreclosureDropdown = {
  items: [
    menuItem(foreclosureMonitoringPath(), 'Výpis'),
    menuItem(foreclosureMapPath(), 'Mapa'),
  ],
}
export const insolvencyDropdown = {
  items: [
    menuItem(viewPath(insolvencyMonitoringPath(), TABLE_VIEW.TABLE), 'Tabulka'),
    menuItem(
      viewPath(insolvencyMonitoringPath(), TABLE_VIEW.COMPACT_TABLE),
      'Přehled'
    ),
    menuItem(viewPath(insolvencyMonitoringPath(), TABLE_VIEW.TILES), 'Náhledy'),
    menuItem(insolvencyMapPath(), 'Mapa'),
  ],
}
export const auctionDropdown = {
  items: [
    menuItem(auctionMonitoringPath(), 'Výpis'),
    menuItem(auctionMapPath(), 'Mapa'),
  ],
}
export const wsdpDropdown = {
  items: [
    menuItem(cuzkLvPath(), 'Listy vlastnictví'),
    menuItem(cuzkEpoPath(), 'Evidence práv pro osobu'),
    menuItem(cuzkMonitorRcPath(), 'Vyhledání osoby'),
    menuItem(cuzkDocumentCollectionPath(), 'Sbírka listin'),
  ],
}
export const watchdogDropdown = {
  items: [
    menuItem(watchdogPropertyPath(), 'Nemovitosti'),
    menuItem(watchdogChannelPath(), 'Kanály'),
  ],
}

export const setTitle = (
  lastItem?: BreadcrumbConfig & { fullPath?: string },
  currentTab?: string | null
) => {
  if (lastItem?.title) {
    let title = lastItem.title

    if (currentTab && lastItem.tabLabels && lastItem.tabLabels[currentTab]) {
      title += ` - ${lastItem.tabLabels[currentTab]}`
    }

    document.title = `${title} - REGESTA DATA 2.0`
  }
}

export const createRouteItem = (
  route: BreadcrumbConfig & { fullPath?: string },
  index: number,
  isLastRoute: boolean,
  currentTab: string | null
) => {
  const isLast = isLastRoute && !currentTab
  const isLink = !isLast && !route.menu && !route.disabled
  const itemPath = route.fullPath + (isLast ? tabQuery(currentTab) : '')

  return {
    key: `${route.path}-${index}`,
    title: isLink ? (
      <Link to={itemPath}>{route.name}</Link>
    ) : (
      <span className="cursor-default text-gray-400">{route.name}</span>
    ),
    menu: route.menu ? { items: route.menu.items } : undefined,
  }
}

export const createTabItem = (
  lastRoute: (BreadcrumbConfig & { fullPath?: string }) | undefined,
  currentTab: string | null
) => {
  if (
    !currentTab ||
    !lastRoute?.tabLabels ||
    !lastRoute?.tabLabels?.[currentTab]
  ) {
    return []
  }

  return [
    {
      key: `${lastRoute.fullPath}${tabQuery(currentTab)}`,
      title: (
        <span className="cursor-default text-gray-400">
          {lastRoute.tabLabels[currentTab]}
        </span>
      ),
    },
  ]
}
